import { api } from '../core';

type BundleRequestDownloadResponse = null;

interface BundleRequestDownloadProps {
  bundleId: string;
  withPageNumbers: boolean;
}

const bundleRequestDownloadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    bundleRequestDownload: builder.mutation<BundleRequestDownloadResponse, BundleRequestDownloadProps>({
      query: ({ bundleId, withPageNumbers }: BundleRequestDownloadProps) => ({
        url: 'bundle/request-download',
        method: 'POST',
        body: {
          bundleId: bundleId,
          withPageNumbers: withPageNumbers
        }
      }),
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in bundleRequestDownload in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useBundleRequestDownloadMutation } = bundleRequestDownloadApi;
